import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import PortfoliosTable from 'components/Portfolios';
import { APPLICATION_CONTAINER_ID, INVESTOR_PROFILE_CONTACT_ID, QUALITY_CHECK_DATA } from 'constants/constants';
import { CreatePortfolioManager } from 'datasource/CreatePortfolio';
import { PortfolioProcessLayoutManager } from 'datasource/PortfolioProcessLayout';
import { StepperManager } from '../../../../core/stepper/StepperManager';
import { useClientProfile } from '../../../../prodivers/clientProfile';
import { useClientLayout } from '../../hooks/useClientLayout';
import './Portfolios.css';

const Portfolios = ({ dfsClientId }: { dfsClientId: string }) => {
    const navigate = useNavigate();

    useClientLayout();

    const {
        sectionedPortfolios, isOverviewLoading, dateOfDeath, clientName, setReFetchPortfolios,
    } = useClientProfile() as any;

    useEffect(() => {
        setReFetchPortfolios?.(true);
    }, [setReFetchPortfolios]);

    const onOpenNewProposal = () => {
        navigate(`/client/${dfsClientId}/portfolios/new-proposal/proposal-product-selection`);
    };

    const onOpenNewPortfolio = () => {
        sessionStorage.removeItem(StepperManager.LOCAL_STORAGE_KEY);
        sessionStorage.removeItem(CreatePortfolioManager.LOCAL_STORAGE_KEY);
        sessionStorage.removeItem(PortfolioProcessLayoutManager.LOCAL_STORAGE_KEY);
        sessionStorage.removeItem(APPLICATION_CONTAINER_ID);
        sessionStorage.removeItem(QUALITY_CHECK_DATA);
        sessionStorage.removeItem(INVESTOR_PROFILE_CONTACT_ID);
        navigate(`/client/${dfsClientId}/portfolios/new-portfolio`);
    };

    return (
        <PortfoliosTable
            isLoading={isOverviewLoading}
            data={sectionedPortfolios}
            expiredClientName={dateOfDeath ? clientName : null}
            onOpenNewPortfolio={onOpenNewPortfolio}
            onOpenNewProposal={onOpenNewProposal}
        />
    );
};

export default Portfolios;
